import DateCollection from 'collections/date';


export default DateCollection.extend({
  initialize: function (models, options) {
    if (typeof options !== 'undefined' && typeof options.activity_collection !== 'undefined') {
      this.activity_collection = options.activity_collection;

      // When items are added/removed trigger change event
      // for the matching activity.
      this.on('add', this.activity_changed, this);
      this.on('remove', this.activity_changed, this);
    }
  },

  activity_changed: function (model, collection, options) {
    var activities = this.activity_collection.where({
      resource_uri: model.get('activity')
    });
    if (activities.length > 0) {
      activities[0].trigger('change');
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/related_activity.js